import { Droppable } from "@hello-pangea/dnd";
import type { IGlobalDroppableProps } from "../types";
import { useGlobalDroppableBooleanOptions } from "./logics";

export const GlobalDroppable = ({
  isCombineEnabled = false,
  isDropDisabled = false,
  children,
  ...props
}: IGlobalDroppableProps) => {
  const combineEnabled = useGlobalDroppableBooleanOptions(isCombineEnabled);
  const dropDisabled = useGlobalDroppableBooleanOptions(isDropDisabled);

  return (
    <Droppable {...props} isCombineEnabled={combineEnabled} isDropDisabled={dropDisabled}>
      {children}
    </Droppable>
  );
};
